import P from '@leverege/promise';
async function fetchSubRsrcImages(subRsrcMap) {
  const imageProms = Object.entries(subRsrcMap).reduce((prev, [key, value]) => {
    prev[key] = () => fetchImage(value.data.url);
    return prev;
  }, {});
  return P.limit(imageProms, {
    handleReject: true
  });
}
async function fetchImage(imageUrl) {
  return new Promise(resolve => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      resolve(img);
    };
    img.onerror = err => {
      console.error(err);
      resolve(null);
    };
    img.src = imageUrl;
  });
}
export default {
  fetchSubRsrcImages
};